"use client";

import { Check, Facebook, Link, Pinterest, Tiktok } from "@ellaandil/ui";
import type { PropsWithChildren } from "react";
import { useState } from "react";

export interface ArticleShareTooltipProps {
	url: string;
}

export const ArticleShareTooltip = ({ url }: ArticleShareTooltipProps) => {
	const [copiedButton, setCopiedButton] = useState<string | null>(null);

	const handleCopyLink = async (buttonId: string) => {
		try {
			await navigator.clipboard.writeText(url);
			setCopiedButton(buttonId);
			setTimeout(() => setCopiedButton(null), 2000);
		} catch (err) {
			console.error("Failed to copy:", err);
		}
	};

	const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
	const pinterestShareUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}`;

	return (
		<div className="flex gap-2">
			<SocialLinkWrapper onClick={() => handleCopyLink("link")}>
				{copiedButton === "link" ? (
					<Check className="size-4 text-text-dark-text-1" />
				) : (
					<Link className="size-4 text-text-dark-text-1 rotate-135" />
				)}
			</SocialLinkWrapper>
			<SocialLinkWrapper href={facebookShareUrl}>
				<Facebook className="size-4 text-text-dark-text-1" />
			</SocialLinkWrapper>
			<SocialLinkWrapper onClick={() => handleCopyLink("tiktok")}>
				{copiedButton === "tiktok" ? (
					<Check className="size-4 text-text-dark-text-1" />
				) : (
					<Tiktok className="size-4 text-text-dark-text-1" />
				)}
			</SocialLinkWrapper>
			<SocialLinkWrapper href={pinterestShareUrl}>
				<Pinterest className="size-4 text-text-dark-text-1" />
			</SocialLinkWrapper>
		</div>
	);
};

const SocialLinkWrapper = ({
	children,
	href,
	onClick,
}: PropsWithChildren<{ href?: string; onClick?: () => void }>) => {
	const className =
		"bg-white h-10 w-10 flex items-center justify-center rounded-xs cursor-pointer hover:bg-neutral-white-90 transition-colors";

	if (href) {
		return (
			<a href={href} target="_blank" rel="noopener noreferrer" className={className}>
				{children}
			</a>
		);
	}

	return (
		<button onClick={onClick} className={className} type="button">
			{children}
		</button>
	);
};
